import { useTranslation } from 'react-i18next';
import { S } from '../../regureStyles';
import Card from './Card';

const SIGNER_STATUS = {
  pending: { color: '#64748b', tKey: 'screens.esign.signerAwaiting' },
  viewed: { color: '#d97706', tKey: 'screens.esign.signerViewed' },
  signed: { color: '#10b981', tKey: 'screens.esign.signerSigned' },
  declined: { color: '#ef4444', tKey: 'screens.esign.signerDeclined' },
};

const SignerProgress = ({ request }) => {
  const { t } = useTranslation();
  return (
    <Card title={t('screens.esign.cardSigners')}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 0, borderRadius: 12, overflow: 'hidden', border: `1px solid ${S.borderLight}` }}>
        {request.signers?.map((signer, i) => {
          const cfg = SIGNER_STATUS[signer.status] || SIGNER_STATUS.pending;
          return (
            <div
              key={i}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 16,
                padding: '16px 20px',
                borderBottom: i < request.signers.length - 1 ? `1px solid ${S.borderLight}` : 'none',
                background: i % 2 === 0 ? '#fff' : S.bgCard,
              }}
            >
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 10,
                  flexShrink: 0,
                  background: `${S.burgundy}14`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: S.burgundy,
                  fontSize: 12,
                  fontWeight: 700,
                }}
              >
                {(signer.name || 'U').slice(0, 2).toUpperCase()}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ fontSize: 14, fontWeight: 600, color: S.textPrimary }}>{signer.name}</span>
                  <span style={{ fontSize: 11, color: S.textMuted }}>{signer.email}</span>
                  <span
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: cfg.color,
                      background: `${cfg.color}14`,
                      padding: '2px 8px',
                      borderRadius: 10,
                      textTransform: 'uppercase',
                    }}
                  >
                    {t(cfg.tKey)}
                  </span>
                </div>
                {signer.signedAt && (
                  <div style={{ marginTop: 6, display: 'flex', gap: 24, flexWrap: 'wrap' }}>
                    <div style={{ fontSize: 12, color: S.textMuted }}>
                      <strong>{t('screens.esign.signedLabel')}</strong> {new Date(signer.signedAt).toLocaleString('en-US')}
                    </div>
                    {signer.ipAddress && (
                      <div style={{ fontSize: 12, color: S.textMuted }}>
                        <strong>{t('screens.esign.ipLabel')}</strong> {signer.ipAddress}
                      </div>
                    )}
                    {signer.signatureMethod && (
                      <div style={{ fontSize: 12, color: S.textMuted }}>
                        <strong>{t('screens.esign.methodLabel')}</strong> {signer.signatureMethod}
                      </div>
                    )}
                    {signer.documentHashAtSigning && (
                      <div style={{ fontSize: 12, color: S.textMuted, fontFamily: 'monospace' }}>
                        <strong>{t('screens.esign.hashLabel')}</strong> {signer.documentHashAtSigning.slice(0, 12)}…
                      </div>
                    )}
                  </div>
                )}
                {signer.declineReason && <div style={{ marginTop: 4, fontSize: 12, color: '#ef4444' }}>{t('screens.esign.declineReasonLabel', { reason: signer.declineReason })}</div>}
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default SignerProgress;
